import { configureStore } from "@reduxjs/toolkit";
import authReducer from "@/modules/auth/store/authSlice";
import uiReducer from "@/modules/shared/store/uiSlice";
import companyReducer from "@/modules/companies/store/companyInfoSlice";
import notificationReducer from "@/modules/notifications/store/notificationsSlice";
import dashboardReducer from "@/modules/tenders/store/dashboardSlice";
import subscriptionsReducer from "@/modules/subscriptions/store/subscriptionSlice";
import announcementReducer from "@/modules/shared/store/announcementSlice";
import authorizedUsersReducer from "@/modules/delegation/store/authorizedUsersSlice";
import referencesReducer from "@/modules/shared/store/referencesSlice";

export default configureStore({
  reducer: {
    dashboard: dashboardReducer,
    auth: authReducer,
    ui: uiReducer,
    company: companyReducer,
    notifications: notificationReducer,
    subscriptions: subscriptionsReducer,
    announcements: announcementReducer,
    authorizedUsers: authorizedUsersReducer,
    references: referencesReducer,
  },
});
